const state = {
    themeColorList: []
}

const mutations = {
    setThemeColor: (state, payload) => {
        state.themeColorList = payload
    }
}

const actions = {
    themeColorList: ({commit}, payload) => {
        commit('setThemeColor', payload)
    }
}

export default {
    state,
    mutations,
    actions
}